'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CheckboxControl = function () {
  function CheckboxControl(element, args) {
    _classCallCheck(this, CheckboxControl);

    var div = document.createElement('div');
    this.input = document.createElement('input');
    this.input.id = window.PRIM.getUUID();
    this.input.checked = args.value ? true : false;
    this.input.type = 'checkbox';
    this.input.disabled = args.readonly ? 'disabled' : '';
    this.input.onchange = args.onchange;
    this.label = document.createElement('label');
    this.label.innerHTML = args.label;
    this.label.htmlFor = this.input.id;

    var fragment = document.createDocumentFragment();
    fragment.appendChild(div);
    div.appendChild(this.label);
    div.appendChild(this.input);

    element.appendChild(fragment);
  }

  _createClass(CheckboxControl, [{
    key: 'setLabel',
    value: function setLabel(text) {
      this.label.innerHTML = text;
    }
  }, {
    key: 'getValue',
    value: function getValue() {
      return this.input.checked;
    }
  }, {
    key: 'setValue',
    value: function setValue(value) {
      this.input.checked = value ? true : false;
    }
  }]);

  return CheckboxControl;
}();

exports.default = CheckboxControl;


//////////////////
// WEBPACK FOOTER
// ./js/lib/ui/CheckboxControl.js
// module id = 27
// module chunks = 0